<div class="container">
  <div class="row">
    @for (report of inventoryReports; track report) {
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 mt-4">
        <!-- Button acts as a card -->
        <button class="btn report-card" (click)="onSelectPhase(report)">
          <div class="card-body text-center">
            <!-- Icon rendering -->
            @if (report.icon.imageEncoded) {
              <div>
                <i [class]="report.icon" class="report-icon"></i>
                <img #image src="{{report.icon.imageEncoded}}"
                  class="report-icon">
              </div>
            } @else {
              <i class="default-icon-class report-icon"></i>
              <img #image src="{{'../../../../assets/images/UI_Elements/HD_transparent_picture.png'}}"
                class="default-icon-class report-icon">
            }
            <!-- Report title -->
            <h5 class="card-tittle mt-2">{{report.name}}</h5>
          </div>
        </button>
      </div>
    }
  </div>
</div>